import { useEffect } from 'react';

const DeviceRedirector = () => {

    useEffect(() => {
        const userAgent = navigator.userAgent;


        const isAndroid = () => {
            return /Android/i.test(userAgent);
        };

        const isIOS = () => {
            return /(iPhone|iPad|iPod)/i.test(userAgent);
        };

        const androidURL = "https://play.google.com/store/apps/details?id=com.gwcore.gimwork";
        const iosURL = "https://apps.apple.com/mx/app/gimwork/id6450014304";

        if (isAndroid()) {
            console.log("Redirecting to Android landing page...");
            window.location.href = androidURL;
        } else if (isIOS()) {
            console.log("Redirecting to iOS landing page...");
            window.location.href = iosURL;
        }


    }, []);


    return null;
};



export default DeviceRedirector;